import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, HelpCircle, ArrowRight } from 'lucide-react';
import { PhoneLinkText } from '../PhoneLinkText';

const homeFaqs = [
  {
    q: 'What areas do you serve?',
    a: 'ComfortMaster Heating & Air proudly serves Central Kentucky including Lexington, Nicholasville, Richmond, Georgetown, Frankfort, Winchester, Versailles, Paris, Danville, and surrounding areas.'
  },
  {
    q: 'Do you offer 24/7 emergency service?',
    a: 'Yes! We offer 24/7 emergency HVAC service. If your heating or cooling system breaks down outside of normal business hours, call us at (859) 357-6803 and we will dispatch a technician to help you.'
  },
  {
    q: 'How often should I have my HVAC system serviced?',
    a: 'We recommend having your HVAC system professionally serviced twice a year - once in the spring for cooling and once in the fall for heating. Regular maintenance helps ensure efficient operation and can prevent costly breakdowns.'
  },
  {
    q: 'What payment methods do you accept?',
    a: 'We accept cash, checks, and all major credit cards including Visa, MasterCard, American Express, and Discover.'
  },
  {
    q: 'What is the Comfort Loyalty Club?',
    a: 'The Comfort Loyalty Club is our monthly maintenance membership ($16/month) that includes two seasonal tune-ups, priority scheduling, 10% discount on repairs, and no overtime charges.'
  }
];

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-stone-200 last:border-b-0">
      <button
        className="w-full py-5 px-6 flex items-center justify-between text-left"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="font-semibold text-slate-900 pr-8">{question}</span>
        <ChevronDown className={`w-5 h-5 text-emerald-600 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="pb-5 px-6 pr-12">
          <p className="text-slate-600 leading-relaxed"><PhoneLinkText text={answer} /></p>
        </div>
      )}
    </div>
  );
};

const FAQSection = () => {
  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left Side - Header */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-emerald-600 rounded-xl flex items-center justify-center">
                <HelpCircle className="w-6 h-6 text-white" />
              </div>
              <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider">FAQ</span>
            </div>
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-slate-900 mb-6">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-slate-600 mb-8">
              Got questions about our HVAC services? We have got answers. Here are some of the most common questions we receive from our customers.
            </p>
            <Link to="/faq" className="btn-primary inline-flex items-center gap-2" data-testid="view-all-faq-btn">
              View All FAQs <ArrowRight size={18} />
            </Link>
          </div>

          {/* Right Side - FAQ Accordion */}
          <div className="bg-stone-50 rounded-2xl p-6 md:p-8">
            {homeFaqs.map((faq, index) => (
              <FAQItem key={index} question={faq.q} answer={faq.a} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
